var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrationPageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 158,
    viewBox: "0 0 200 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Char 14",
    clipPath: "url(#clip0_815_118725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.1508 118.394C7.1508 118.394 2.05329 116.063 0.0635109 120.113C-1.92627 124.164 5.3529 128.318 9.31161 127.125C13.2745 125.932 12.5779 119.963 7.1508 118.394Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.6382 45.3584C87.6382 45.3584 82.0902 43.6189 80.5676 48.0448C79.0451 52.4707 87.0709 55.8037 90.9921 54.0601C94.9132 52.3206 93.424 46.2678 87.6382 45.3542V45.3584Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M107.649 1.90906V31.8726C107.649 32.661 108.288 33.2951 109.072 33.2951H159.788C160.577 33.2951 161.211 32.6569 161.211 31.8726V1.90489C161.215 1.12065 160.577 0.482422 159.788 0.482422H109.072C108.284 0.482422 107.649 1.12065 107.649 1.90906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M138.833 18.8834C138.833 21.3153 139.755 23.5345 141.265 25.2073C142.992 27.122 145.491 28.3234 148.273 28.3234C153.487 28.3234 157.713 24.0977 157.713 18.8834C157.713 17.5902 157.454 16.3596 156.983 15.2333L148.273 18.8834L148.719 9.45587C148.573 9.44753 148.423 9.44336 148.273 9.44336C143.059 9.44336 138.833 13.669 138.833 18.8834Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M149.658 7.90039C152.478 8.02971 154.973 9.39794 156.616 11.4753C157.146 12.1428 157.584 12.8853 157.918 13.682L149.212 17.3279L149.658 7.90039Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M116.113 12.3848H117.41V13.6821H116.113V12.3848Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M110.594 12.8672H115.241C115.248 12.8672 115.254 12.8728 115.254 12.8797V13.18C115.254 13.187 115.248 13.1926 115.241 13.1926H110.594C110.587 13.1926 110.582 13.187 110.582 13.18V12.8797C110.582 12.8728 110.587 12.8672 110.594 12.8672Z",
    fill: "#E8D3E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M116.113 10.0742H117.41V11.3715H116.113V10.0742Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M110.594 10.5566H115.241C115.248 10.5566 115.254 10.5622 115.254 10.5692V10.8695C115.254 10.8764 115.248 10.882 115.241 10.882H110.594C110.587 10.882 110.582 10.8764 110.582 10.8695V10.5692C110.582 10.5622 110.587 10.5566 110.594 10.5566Z",
    fill: "#E8D3E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M116.113 14.6914H117.41V15.9887H116.113V14.6914Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M110.594 15.1777H115.241C115.248 15.1777 115.254 15.1833 115.254 15.1902V15.4906C115.254 15.4975 115.248 15.5031 115.241 15.5031H110.594C110.587 15.5031 110.582 15.4975 110.582 15.4906V15.1902C110.582 15.1833 110.587 15.1777 110.594 15.1777Z",
    fill: "#E8D3E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M110.744 20.05H117.247C117.335 20.05 117.41 19.9791 117.41 19.8873C117.41 19.7997 117.339 19.7246 117.247 19.7246H110.744C110.657 19.7246 110.581 19.7955 110.581 19.8873C110.581 19.9749 110.652 20.05 110.744 20.05Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M110.744 21.382H117.247C117.335 21.382 117.41 21.3111 117.41 21.2193C117.41 21.1317 117.339 21.0566 117.247 21.0566H110.744C110.657 21.0566 110.581 21.1276 110.581 21.2193C110.581 21.3069 110.652 21.382 110.744 21.382Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M110.744 22.716H117.247C117.335 22.716 117.41 22.6451 117.41 22.5533C117.41 22.4657 117.339 22.3906 117.247 22.3906H110.744C110.657 22.3906 110.581 22.4615 110.581 22.5533C110.581 22.6409 110.652 22.716 110.744 22.716Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M110.744 24.0461H117.247C117.335 24.0461 117.41 23.9752 117.41 23.8834C117.41 23.7958 117.339 23.7207 117.247 23.7207H110.744C110.657 23.7207 110.581 23.7916 110.581 23.8834C110.581 23.971 110.652 24.0461 110.744 24.0461Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M110.744 25.3801H117.247C117.335 25.3801 117.41 25.3091 117.41 25.2174C117.41 25.1298 117.339 25.0547 117.247 25.0547H110.744C110.657 25.0547 110.581 25.1256 110.581 25.2174C110.581 25.305 110.652 25.3801 110.744 25.3801Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M110.744 26.7121H117.247C117.335 26.7121 117.41 26.6412 117.41 26.5494C117.41 26.4618 117.339 26.3867 117.247 26.3867H110.744C110.657 26.3867 110.581 26.4576 110.581 26.5494C110.581 26.637 110.652 26.7121 110.744 26.7121Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M110.744 28.0461H117.247C117.335 28.0461 117.41 27.9752 117.41 27.8834C117.41 27.7958 117.339 27.7207 117.247 27.7207H110.744C110.657 27.7207 110.581 27.7916 110.581 27.8834C110.581 27.971 110.652 28.0461 110.744 28.0461Z",
    fill: "#E8D3E7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M107.649 1.90906V4.40776H161.215V1.90489C161.215 1.12065 160.577 0.482422 159.788 0.482422H109.072C108.283 0.482422 107.649 1.12065 107.649 1.90906Z",
    fill: "#28100C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M113.293 2.44815C113.293 2.81107 113.589 3.10724 113.952 3.10724C114.315 3.10724 114.611 2.81107 114.611 2.44815C114.611 2.08524 114.315 1.78906 113.952 1.78906C113.589 1.78906 113.293 2.08524 113.293 2.44815Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M111.153 2.44815C111.153 2.81107 111.449 3.10724 111.812 3.10724C112.175 3.10724 112.471 2.81107 112.471 2.44815C112.471 2.08524 112.175 1.78906 111.812 1.78906C111.449 1.78906 111.153 2.08524 111.153 2.44815Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M109.106 2.44815C109.106 2.81107 109.402 3.10724 109.765 3.10724C110.128 3.10724 110.424 2.81107 110.424 2.44815C110.424 2.08524 110.128 1.78906 109.765 1.78906C109.402 1.78906 109.106 2.08524 109.106 2.44815Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M138.834 18.8834C138.834 21.3153 139.756 23.5345 141.266 25.2073L148.274 18.8834L148.721 9.45587C148.575 9.44753 148.425 9.44336 148.274 9.44336C143.06 9.44336 138.834 13.669 138.834 18.8834Z",
    fill: "#F55468"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M126.639 16.4961H129.643V29.3734H126.639V16.4961Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M129.643 25.9776C128.579 25.648 127.578 25.0598 126.639 24.4258V29.3731H129.643V25.9776Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M131.553 20.0723H134.557V29.3704H131.553V20.0723Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M132.108 26.1923C131.92 26.2215 131.737 26.2382 131.553 26.2424V29.371H134.557V26.2716C134.027 26.0964 133.247 26.0255 132.108 26.1923Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M121.731 12.6484H124.734V29.3718H121.731V12.6484Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M121.727 21.8125V29.3712H124.73V23.0973C123.663 22.3715 122.666 21.8084 121.727 21.8125Z",
    fill: "#21223D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M121.848 7.77201L124.56 8.35185L123.83 9.06517L127.98 13.2992L129.436 11.8684L134.588 17.1202C134.784 17.3205 134.78 17.6417 134.58 17.8377C134.379 18.0338 134.058 18.0296 133.862 17.8294L129.42 13.3034L127.964 14.7342L123.1 9.77431L122.37 10.4876L121.84 7.76367L121.848 7.77201Z",
    fill: "#21223D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M131.924 94.1289V43.3706C131.924 42.5947 132.554 41.9648 133.33 41.9648H159.018C159.794 41.9648 160.424 42.5947 160.424 43.3706V94.1289C160.424 95.6973 159.152 96.9738 157.579 96.9738H134.765C133.197 96.9738 131.92 95.7015 131.92 94.1289H131.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M136.191 80.5132H155.175C155.521 80.5132 155.801 80.2337 155.801 79.8874C155.801 79.5412 155.521 79.2617 155.175 79.2617H136.191C135.845 79.2617 135.565 79.5412 135.565 79.8874C135.565 80.2337 135.845 80.5132 136.191 80.5132Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M136.191 84.4839H155.175C155.521 84.4839 155.801 84.2044 155.801 83.8581C155.801 83.5119 155.521 83.2324 155.175 83.2324H136.191C135.845 83.2324 135.565 83.5119 135.565 83.8581C135.565 84.2044 135.845 84.4839 136.191 84.4839Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M136.191 88.4565H155.175C155.521 88.4565 155.801 88.177 155.801 87.8308C155.801 87.4846 155.521 87.2051 155.175 87.2051H136.191C135.845 87.2051 135.565 87.4846 135.565 87.8308C135.565 88.177 135.845 88.4565 136.191 88.4565Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M136.191 92.4272H155.175C155.521 92.4272 155.801 92.1477 155.801 91.8015C155.801 91.4553 155.521 91.1758 155.175 91.1758H136.191C135.845 91.1758 135.565 91.4553 135.565 91.8015C135.565 92.1477 135.845 92.4272 136.191 92.4272Z",
    fill: "#E8D3E7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M131.924 43.3706V47.2668H160.424V43.3706C160.424 42.5947 159.794 41.9648 159.018 41.9648H133.33C132.554 41.9648 131.924 42.5947 131.924 43.3706Z",
    fill: "#28100C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M138.824 44.3597C138.824 44.8727 139.237 45.2857 139.75 45.2857C140.263 45.2857 140.676 44.8727 140.676 44.3597C140.676 43.8466 140.263 43.4336 139.75 43.4336C139.237 43.4336 138.824 43.8466 138.824 44.3597Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M135.822 44.3597C135.822 44.8727 136.235 45.2857 136.748 45.2857C137.261 45.2857 137.674 44.8727 137.674 44.3597C137.674 43.8466 137.261 43.4336 136.748 43.4336C136.235 43.4336 135.822 43.8466 135.822 44.3597Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M132.947 44.3597C132.947 44.8727 133.36 45.2857 133.873 45.2857C134.386 45.2857 134.799 44.8727 134.799 44.3597C134.799 43.8466 134.386 43.4336 133.873 43.4336C133.36 43.4336 132.947 43.8466 132.947 44.3597Z",
    fill: "#21223D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M151.578 68.9941H154.781V76.7405H151.578V68.9941Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M146.851 63.4922H150.055V76.7366H146.851V63.4922Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M141.617 59.4336H144.82V76.741H141.617V59.4336Z",
    fill: "#F55468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M136.486 54.6699H139.689V76.7369H136.486V54.6699Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M142.393 51.2778L140.173 52.0913L140.428 49.4883L142.393 51.2778Z",
    fill: "#E8D3E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M155.666 65.2325C155.762 65.2325 155.854 65.1741 155.891 65.0782C155.937 64.953 155.875 64.8154 155.749 64.7695C155.653 64.7319 146.005 61.036 141.299 51.1038C141.241 50.9828 141.099 50.9328 140.978 50.9912C140.857 51.0496 140.807 51.1914 140.866 51.3124C145.659 61.4281 155.482 65.1866 155.578 65.2242C155.608 65.2325 155.633 65.2409 155.662 65.2409L155.666 65.2325Z",
    fill: "#E8D3E7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M97.4587 2.44098V10.3626C97.4587 11.4096 96.6077 12.2606 95.5607 12.2606H81.1775L76.8351 13.8165C76.3887 13.9751 75.9632 13.537 76.1343 13.099L77.7778 8.85668V2.44098C77.7778 1.39395 78.6288 0.542969 79.6758 0.542969H95.5649C96.6119 0.542969 97.4629 1.39395 97.4629 2.44098H97.4587Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M84.9629 6.62827C84.9629 7.38747 84.3497 8.00068 83.5905 8.00068C82.8313 8.00068 82.2181 7.38747 82.2181 6.62827C82.2181 5.86906 82.8313 5.25586 83.5905 5.25586C84.3497 5.25586 84.9629 5.86906 84.9629 6.62827Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M89.3066 6.62827C89.3066 7.38747 88.6934 8.00068 87.9342 8.00068C87.175 8.00068 86.5618 7.38747 86.5618 6.62827C86.5618 5.86906 87.175 5.25586 87.9342 5.25586C88.6934 5.25586 89.3066 5.86906 89.3066 6.62827Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M93.6484 6.62827C93.6484 7.38747 93.0352 8.00068 92.276 8.00068C91.5168 8.00068 90.9036 7.38747 90.9036 6.62827C90.9036 5.86906 91.5168 5.25586 92.276 5.25586C93.0352 5.25586 93.6484 5.86906 93.6484 6.62827Z",
    fill: "#6BD17C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M57.5607 3.05078H50.7111C50.269 3.05078 49.9144 3.40953 49.9144 3.84753V10.6971C49.9144 11.1392 50.2731 11.4938 50.7111 11.4938H57.5607C58.0028 11.4938 58.3574 11.1351 58.3574 10.6971V3.8517C58.3574 3.40953 57.9987 3.05495 57.5607 3.05495V3.05078Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M51.7497 5.53619C51.7622 5.47779 51.7789 5.41939 51.7914 5.36099C51.8415 5.15659 51.9416 4.97722 52.0793 4.81453C52.1794 4.7019 52.292 4.60179 52.4213 4.5267C52.6007 4.42242 52.8009 4.4683 52.9344 4.62682C53.168 4.91048 53.4058 5.19414 53.6352 5.48197C53.777 5.65717 53.7562 5.89911 53.5768 6.05345C53.4517 6.16608 53.3182 6.27037 53.1847 6.37883C53.168 6.39134 53.1471 6.40386 53.1346 6.4122C53.4475 7.25066 53.9773 7.90141 54.7365 8.36861C54.8282 8.29353 54.9242 8.2101 55.0201 8.13084C55.0702 8.08912 55.1202 8.04741 55.1703 8.00987C55.3246 7.89307 55.4999 7.88055 55.6584 7.98484C55.7084 8.01821 55.7501 8.06827 55.7877 8.11415C56.0004 8.37278 56.209 8.63141 56.4217 8.88587C56.4885 8.96513 56.5302 9.0569 56.5469 9.16119L56.5344 9.27382C56.4968 9.33639 56.4718 9.41565 56.4217 9.4657C56.2966 9.59085 56.1589 9.69931 55.9963 9.77439C55.8044 9.86199 55.6041 9.91205 55.3956 9.89536C55.2579 9.88285 55.1202 9.85365 54.9868 9.81611C54.6447 9.72016 54.3277 9.55748 54.0357 9.35725C53.7437 9.16119 53.4767 8.93176 53.2347 8.6773C52.9052 8.33524 52.6132 7.96398 52.3462 7.56769C52.1377 7.259 51.9583 6.93363 51.8373 6.57489C51.7789 6.39551 51.7372 6.21197 51.7247 6.02008C51.7205 5.945 51.7163 5.86574 51.7163 5.79065L51.7414 5.52785L51.7497 5.53619Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M45.4215 2.90039H38.2758C37.8819 2.90039 37.5625 3.21975 37.5625 3.61371V10.7594C37.5625 11.1534 37.8819 11.4727 38.2758 11.4727H45.4215C45.8155 11.4727 46.1348 11.1534 46.1348 10.7594V3.61371C46.1348 3.21975 45.8155 2.90039 45.4215 2.90039Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M44.5826 7.02686C44.5826 8.09476 43.9819 8.64956 43.2686 8.64956C42.8473 8.64956 42.5428 8.48687 42.3842 8.1615C42.2257 8.47019 41.9587 8.64956 41.5333 8.64956C40.9284 8.64956 40.3486 8.11979 40.3486 7.25629C40.3486 6.3928 40.9117 5.8672 41.5333 5.8672C41.8294 5.8672 42.0589 5.96314 42.2215 6.14252V5.91726H43.2978V7.5191C43.2978 7.7527 43.3937 7.82778 43.5147 7.82778C43.6732 7.82778 43.7984 7.66927 43.7984 7.04355C43.7984 6.02989 43.0433 5.31657 41.892 5.31657C40.7407 5.31657 39.9731 6.12166 39.9731 7.18538C39.9731 8.2491 40.7282 9.06671 41.8711 9.06671C42.2424 9.06671 42.622 8.99579 43.0016 8.82059L43.2352 9.50888C42.9015 9.67157 42.3675 9.77585 41.8711 9.77585C40.1859 9.77585 39.1055 8.64956 39.1055 7.18538C39.1055 5.7212 40.1859 4.60742 41.892 4.60742C43.5022 4.60742 44.5826 5.68783 44.5826 7.03104V7.02686ZM42.2424 7.25629C42.2424 6.92258 42.0672 6.74738 41.8378 6.74738C41.6083 6.74738 41.4415 6.92258 41.4415 7.25629C41.4415 7.59001 41.6083 7.76938 41.8378 7.76938C42.0672 7.76938 42.2424 7.59418 42.2424 7.25629Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M33.8707 2.90039H26.725C26.3311 2.90039 26.0117 3.21975 26.0117 3.61371V10.7594C26.0117 11.1534 26.3311 11.4727 26.725 11.4727H33.8707C34.2647 11.4727 34.584 11.1534 34.584 10.7594V3.61371C34.584 3.21975 34.2647 2.90039 33.8707 2.90039Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M30.7425 9.16149V9.77052L29.9624 9.76218V9.17818C29.416 9.14064 28.8862 8.98629 28.5566 8.78189L28.9821 7.83914C29.345 8.05606 29.8248 8.19789 30.2502 8.20206C30.6173 8.20206 30.7508 8.13114 30.7508 7.99766C30.7508 7.51377 28.6234 7.88503 28.6359 6.45422C28.6401 5.83267 29.0948 5.31541 30 5.19444V4.59375L30.78 4.60209V5.19027C31.1805 5.23198 31.5768 5.34044 31.8896 5.51981L31.4933 6.45839C31.1137 6.26233 30.7592 6.16639 30.4254 6.16222C30.0458 6.16222 29.9249 6.2665 29.9249 6.39999C29.9249 6.86302 32.0523 6.49593 32.0398 7.91423C32.0356 8.50657 31.6018 9.01966 30.7508 9.16149H30.7425Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M178.947 57.4395C174.324 52.8162 174.324 45.3205 178.947 40.6972C183.57 36.074 191.066 36.074 195.689 40.6972C200.313 45.3205 200.313 52.8162 195.689 57.4395C191.066 62.0628 183.57 62.0628 178.947 57.4395Z",
    fill: "#F2D6BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M178.947 55.8946C174.324 51.2713 174.324 43.7756 178.947 39.1523C183.57 34.529 191.066 34.529 195.689 39.1523C200.313 43.7755 200.313 51.2713 195.689 55.8946C191.066 60.5178 183.57 60.5178 178.947 55.8946Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M177.812 49.0548C176.967 43.8053 180.537 38.8642 185.786 38.0186C191.036 37.1731 195.977 40.7433 196.823 45.9928C197.668 51.2424 194.098 56.1835 188.848 57.029C183.599 57.8746 178.658 54.3044 177.812 49.0548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M196.943 47.5262C196.943 47.7806 196.934 48.0351 196.914 48.2854C196.526 43.3297 192.367 39.421 187.319 39.421C182.272 39.421 178.113 43.3338 177.725 48.2854C177.704 48.0351 177.696 47.7806 177.696 47.5262C177.696 42.2159 182.013 37.8984 187.323 37.8984C192.63 37.8984 196.951 42.2159 196.951 47.5262H196.943Z",
    fill: "#F2D6BA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M187.318 48.5265C187.243 48.5265 187.172 48.4931 187.126 48.4305L182.404 42.0733C182.325 41.9648 182.346 41.8146 182.454 41.7354C182.563 41.6561 182.713 41.677 182.792 41.7854L187.401 47.9884L192.637 45.6899C192.758 45.6357 192.899 45.6899 192.954 45.815C193.008 45.936 192.954 46.0778 192.829 46.1321L187.418 48.5056C187.385 48.5181 187.356 48.5265 187.322 48.5265H187.318Z",
    fill: "#28100C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M23.5566 91.0254L3.24508 85.132L0.880756 93.2807C0.306531 95.2598 1.44691 97.3324 3.42599 97.9066L16.5624 101.718C18.5415 102.292 20.6141 101.152 21.1883 99.1729L23.5526 91.0242L23.5566 91.0254Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M19.4258 92.5024L5.59742 88.5938",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M7.00586 91.3712L5.03693 90.8164",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M18.8711 94.7256L9.24755 92.0059",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M17.9668 97.3653L12.1309 95.6133",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M3.54328 81.4307L25.2891 87.7402L24.2766 91.2297L2.53083 84.9201L3.54328 81.4307Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M24.2754 91.2131C23.8332 89.8699 23.3785 88.3807 22.9364 87.0375L21.3345 86.5703C21.8893 87.9844 22.2606 89.2609 22.6235 90.7334C22.6235 90.7334 23.7915 91.0797 24.2712 91.209L24.2754 91.2131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M20.4492 90.0966C20.007 88.7534 19.5607 87.2808 19.1185 85.9376L17.5375 85.4746C18.0923 86.8887 18.4886 88.161 18.8515 89.6377L20.4492 90.0966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M16.0527 88.8349C15.6106 87.4917 15.1559 85.9983 14.7137 84.6551L13.0034 84.1504C13.554 85.5645 13.9962 86.8577 14.3591 88.3302L16.0527 88.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M11.6758 87.5635C11.2336 86.2203 10.7706 84.7019 10.3284 83.3587C10.3284 83.3587 8.74741 82.9499 8.7349 82.9082C9.2897 84.3223 9.71937 85.6196 10.0823 87.0922C10.0823 87.0922 11.6716 87.5427 11.6716 87.5594L11.6758 87.5635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M7.44727 86.3281C7.00509 84.9849 6.54623 83.4957 6.10406 82.1525L4.51474 81.6895L5.87046 85.8693L7.44727 86.3323V86.3281Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M8.66692 72.0077L27.3184 84.8457L25.2583 87.8386L6.60689 75.0006L8.66692 72.0077Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M25.2607 87.837C25.2607 86.4229 25.3025 84.8669 25.3066 83.4528L23.9342 82.5059C24.0135 84.0201 23.9676 85.3508 23.8466 86.865C23.8466 86.865 24.8436 87.5617 25.2607 87.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M21.9815 85.5717C21.9815 84.1576 22.0232 82.6183 22.0273 81.2042L20.6716 80.2656C20.7509 81.7799 20.7259 83.1147 20.6091 84.629L21.9815 85.5717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M18.2061 82.9902C18.2061 81.5761 18.2478 80.0159 18.252 78.6018L16.7878 77.584C16.867 79.0982 16.8796 80.4665 16.7586 81.9765L18.2102 82.9902H18.2061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M14.4522 80.4022C14.4522 78.9881 14.4939 77.4029 14.498 75.9888C14.498 75.9888 13.1298 75.1003 13.1298 75.0586C13.2091 76.5728 13.2132 77.9411 13.0923 79.4553C13.0923 79.4553 14.4605 80.3814 14.4522 80.4022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M10.8235 77.8995C10.8235 76.4854 10.8611 74.9294 10.8652 73.5111L9.50116 72.5684L9.47197 76.9609L10.8235 77.8953V77.8995Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M19.5508 99.5762C18.7874 100.402 17.5694 100.778 16.4723 100.527",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M14.1953 99.6124L8.96848 98.0898",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M196.558 70.1758H170.724C169.381 70.1758 168.293 71.2645 168.293 72.6077V90.0402C168.293 91.9549 169.844 93.5067 171.759 93.5067H195.524C197.438 93.5067 198.99 91.9549 198.99 90.0402V72.6077C198.99 71.2645 197.901 70.1758 196.558 70.1758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M196.558 70.1758H170.724C169.381 70.1758 168.293 71.2645 168.293 72.6077V72.9623H198.99V72.6077C198.99 71.2645 197.901 70.1758 196.558 70.1758Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M196.917 71.568C196.917 71.7682 197.079 71.9309 197.28 71.9309C197.48 71.9309 197.643 71.7682 197.643 71.568C197.643 71.3678 197.48 71.2051 197.28 71.2051C197.079 71.2051 196.917 71.3678 196.917 71.568Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M195.45 71.9309C195.249 71.9309 195.087 71.7684 195.087 71.568C195.087 71.3676 195.249 71.2051 195.45 71.2051C195.65 71.2051 195.812 71.3676 195.812 71.568C195.812 71.7684 195.65 71.9309 195.45 71.9309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M193.461 71.9309C193.261 71.9309 193.098 71.7684 193.098 71.568C193.098 71.3676 193.261 71.2051 193.461 71.2051C193.662 71.2051 193.824 71.3676 193.824 71.568C193.824 71.7684 193.662 71.9309 193.461 71.9309Z",
    fill: "#C7B7DA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M195.878 89.8613H197.672V91.655H195.878V89.8613Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M196.996 91.0624V90.4492",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M196.559 91.0624V90.4492",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M170.628 90.3184H195.314V91.307H170.628V90.3184Z",
    fill: "#E5DBED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M185.057 90.3184H195.314V91.307H185.057V90.3184Z",
    fill: "#63658E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M168.953 75.752V83.7945",
    stroke: "#63658E",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M168.953 74.1055V74.9064",
    stroke: "#63658E",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M194.396 92.9824H184.752",
    stroke: "#63658E",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M181.516 86.3353C179.159 85.3718 178.03 82.6805 178.994 80.3242C179.957 77.9678 182.649 76.8387 185.005 77.8023C187.361 78.7658 188.49 81.4571 187.527 83.8134C186.563 86.1698 183.872 87.2989 181.516 86.3353Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M184.668 83.847V80.293L181.343 81.7446L184.668 83.847Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M186.547 80.1264C185.996 78.8833 184.615 78.0657 183.264 78.1783",
    stroke: "#63658E",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M80.0643 153.239C38.494 153.239 4.79465 149.907 4.79465 145.797C4.79465 141.687 38.494 138.355 80.0643 138.355C121.635 138.355 155.334 141.687 155.334 145.797C155.334 149.907 121.635 153.239 80.0643 153.239Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M122.26 134.745C121.372 135.633 120.408 136.48 119.361 137.281C114.13 141.298 106.897 144.176 97.2902 145.14C48.163 150.058 31.9277 127.011 27.9607 91.5536C26.192 75.7521 30.33 65.3235 35.4609 58.62C35.999 57.9192 36.5455 57.2601 37.0961 56.6385C37.409 56.2881 37.726 55.9461 38.0556 55.6124C44.6798 48.8463 54.245 45.6593 63.6432 47.2069C71.0309 48.4208 77.7428 52.367 83.1865 60.2552C91.8965 72.8655 83.6579 83.7071 108.545 84.4329C127.596 84.9877 139.668 117.379 122.256 134.749L122.26 134.745Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M47.0497 58.1793C47.0497 58.1793 41.2388 70.6103 47.9465 93.4281C54.6542 116.246 63.5394 114.448 69.2793 114.448C79.3075 114.448 99.6141 105.004 103.581 97.562C107.548 90.1202 100.06 89.678 86.0402 88.5767C72.0158 87.4754 61.5538 53.257 47.0497 58.1793Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M59.6468 124.021C59.5383 124.021 59.4257 123.979 59.3422 123.892C59.1837 123.725 59.1879 123.462 59.3589 123.299C64.373 118.531 69.1618 115.724 72.2988 114.206C75.7068 112.558 77.9052 112.045 77.997 112.024C78.2222 111.974 78.4475 112.112 78.4976 112.337C78.5476 112.562 78.4099 112.787 78.1847 112.837C78.0846 112.862 69.3537 114.948 59.9388 123.904C59.8595 123.979 59.7552 124.021 59.6509 124.021H59.6468Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M61.3025 118.433C61.169 118.433 61.0356 118.371 60.9563 118.25C60.827 118.058 60.877 117.799 61.0689 117.67C61.265 117.537 65.9328 114.441 73.1578 113.653C73.3872 113.628 73.5916 113.795 73.6167 114.024C73.6417 114.254 73.4748 114.458 73.2454 114.483C66.2248 115.251 61.5778 118.329 61.532 118.362C61.461 118.413 61.3776 118.433 61.2984 118.433H61.3025Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M46.1515 83.9117C45.9429 83.9117 45.7635 83.7574 45.7385 83.5447C45.1336 78.7099 43.0521 75.014 41.4169 72.7656C39.6357 70.3211 37.9754 69.0071 37.9587 68.9946C37.7794 68.8528 37.746 68.59 37.8878 68.4064C38.0296 68.2229 38.2925 68.1937 38.476 68.3355C38.5469 68.3898 40.228 69.7205 42.0759 72.2484C43.7779 74.5802 45.9387 78.4138 46.5728 83.4404C46.602 83.6698 46.4393 83.8784 46.2099 83.9076C46.1932 83.9076 46.1765 83.9076 46.1556 83.9076L46.1515 83.9117Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M122.26 134.746C121.371 135.634 120.408 136.481 119.361 137.282C113.316 140.911 105.937 143.301 97.8109 144.236C95.2913 144.528 92.7467 144.67 90.2022 144.67C83.1858 144.67 76.1527 143.577 69.5243 141.428C52.2795 135.843 39.8361 123.892 34.4883 107.781C31.5557 98.9463 30.1166 90.3573 30.2083 82.248C30.2793 75.7531 31.3346 69.5501 33.3328 63.8102C34.0002 61.8955 34.726 60.1685 35.4602 58.6209C35.9983 57.9201 36.5448 57.261 37.0954 56.6395C37.4083 56.2891 37.7253 55.947 38.0548 55.6133C36.745 57.8575 35.3434 60.7066 34.1462 64.1481C31.0635 73.0208 28.765 87.746 35.3225 107.502C40.5786 123.341 52.8218 135.092 69.7912 140.59C87.8203 146.43 108.673 144.061 121.68 134.7C121.859 134.571 122.101 134.596 122.251 134.75L122.26 134.746Z",
    fill: "#EEF0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M47.1851 142.789C47.1184 143.081 47.0391 143.368 46.9474 143.648C46.3341 145.529 45.2079 147.031 43.6769 147.652C37.8786 150.005 32.4265 149.192 21.3305 148.933C10.2386 148.675 1.99996 145.738 3.02614 136.602C3.10957 135.881 3.24723 135.209 3.43494 134.579C3.68106 133.753 4.01477 133.007 4.41106 132.331C4.87409 131.534 5.42472 130.833 6.02541 130.224C9.13731 127.062 13.826 126.028 18.0267 127.467C22.1731 128.889 29.5023 129.578 37.1319 129.728C45.3288 129.895 48.3948 137.553 47.1851 142.78V142.789Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M47.1855 142.788C47.1188 143.08 47.0395 143.367 46.9478 143.647C44.983 145.361 41.2788 146.446 35.9101 146.872C34.2248 147.009 32.3685 147.072 30.3746 147.072C25.7568 147.072 20.3756 146.713 14.498 146.008C9.52568 145.411 6.16349 143.659 4.49908 140.802C3.26016 138.675 3.19759 136.351 3.43536 134.582C3.68148 133.756 4.01519 133.01 4.41148 132.334C3.98182 133.656 3.0349 137.411 4.88286 140.585C6.47218 143.317 9.72591 144.994 14.5523 145.574C31.9889 147.668 43.8567 146.65 47.1855 142.788Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M14.0352 131.488C10.6271 131.764 8.10757 134.871 8.66655 138.246C8.67906 138.313 8.6874 138.375 8.70409 138.442C9.43826 142.117 14.3814 142.009 28.1055 142.138C38.8553 142.238 44.3825 138.392 41.5209 133.641C39.2474 129.862 21.2935 130.904 14.0352 131.488Z",
    fill: "#6BD17C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M39.9597 134.271C34.9581 140.499 14.5597 140.85 11.8816 136.186C10.576 133.917 10.9389 131.005 11.648 128.619C11.7231 128.369 11.8024 128.123 11.8816 127.885C12.6158 125.736 13.5377 124.168 13.5377 124.168C13.5377 124.168 13.4543 126.387 20.9796 125.59C21.8389 125.499 22.8192 125.461 23.8662 125.474C24.0623 125.474 24.2583 125.478 24.4586 125.486C32.572 125.728 44.2771 128.894 39.9555 134.275L39.9597 134.271Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M23.5696 130.558C22.3933 131.872 20.3451 132.368 17.6545 131.989C17.5919 131.98 17.5336 131.972 17.4752 131.964C14.0838 131.442 12.4319 129.828 11.6518 128.618C11.7269 128.368 11.8062 128.122 11.8854 127.884C12.4611 128.998 13.9795 130.896 17.738 131.421C20.2283 131.772 22.1013 131.338 23.1442 130.174C24.0827 129.123 24.333 127.5 23.8742 125.469C24.0702 125.469 24.2663 125.473 24.4665 125.481C24.9295 127.642 24.6208 129.39 23.5738 130.558H23.5696Z",
    fill: "#FBAB47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M37.1318 129.738C37.1318 129.738 41.9206 129.383 42.4879 126.968C43.0552 124.553 32.0676 126.672 30.8579 121.691C29.644 116.714 34.5038 112.743 36.0806 114.199C37.9494 115.926 33.8572 116.66 33.6361 119.222C33.4525 121.349 34.7707 123.31 38.8629 123.602C42.9551 123.894 44.7822 124.528 44.7655 126.43C44.7447 128.499 41.4325 130.635 39.4177 130.768C37.4029 130.902 37.1318 129.738 37.1318 129.738Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M16.1228 122.332C16.1228 122.332 14.7003 120.484 12.3893 119.254C12.0514 119.075 11.651 119.346 11.6927 119.725L12.1307 123.963C12.1307 123.963 15.4512 124.247 16.127 122.337L16.1228 122.332Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M12.9408 123.451C12.7531 122.492 12.7072 121.482 12.4862 120.348C12.4862 120.348 14.9849 121.837 15.1309 122.654C15.1309 122.654 13.7543 123.697 12.9408 123.451Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M20.4569 122.502C20.4569 122.502 22.4091 121.326 24.9662 121.005C25.3834 120.95 25.6921 121.392 25.5043 121.772L23.7565 125.259C23.7565 125.259 20.3901 124.529 20.4611 122.502H20.4569Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M23.0146 124.701C23.5402 123.875 23.949 122.949 24.5664 121.977C24.5664 121.977 21.7006 122.456 21.2626 123.165C21.2626 123.165 22.1678 124.638 23.0146 124.705V124.701Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M14.2671 122.409C14.2671 122.409 11.3096 122.859 11.5307 126.326C11.7518 129.792 15.1265 130.16 15.1265 130.16C15.1265 130.16 15.7272 131.273 17.8129 131.724C19.1477 132.012 21.1334 131.92 21.6381 130.94C21.6381 130.94 24.5331 129.88 24.4997 127.298C24.4622 124.436 21.0166 120.924 14.2671 122.409Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M11.2605 130.602C11.2605 130.602 12.466 135.52 13.4797 136.538C14.4892 137.551 15.5863 138.11 16.9963 138.281C19.2697 138.557 18.8525 140.075 18.1726 140.596C17.3884 141.201 15.9951 140.855 13.901 140.855C12.0948 140.855 10.3928 140.496 9.77963 139.307C9.1706 138.119 9.20814 134.606 9.85889 132.629C10.2593 131.411 10.8225 130.773 11.2563 130.606L11.2605 130.602Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M26.5412 130.926C26.5412 130.926 25.3356 135.844 24.322 136.862C23.3125 137.875 22.2071 138.38 20.8054 138.605C19.091 138.877 19.2495 140.495 19.6291 140.921C20.2924 141.659 21.8066 141.179 23.9007 141.179C25.7069 141.179 27.8427 140.458 28.4559 139.269C29.0649 138.08 28.5935 134.93 27.9428 132.953C27.5423 131.735 26.9792 131.097 26.5454 130.93L26.5412 130.926Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M36.6396 129.948C36.6396 129.948 39.8224 129.184 40.8486 131.583C42.463 135.354 41.174 137.51 36.8732 138.111C32.5725 138.712 27.6877 139.525 31.3794 136.463C35.0753 133.406 36.6396 129.948 36.6396 129.948Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M19.5115 128.007C19.5115 128.007 18.2267 127.869 17.8846 128.027C17.309 128.29 18.235 129.362 18.8232 129.454C19.4114 129.546 19.9829 128.858 19.9745 128.407C19.9662 127.961 19.5115 128.007 19.5115 128.007Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M20.1708 127.018C20.1082 126.98 20.0414 127.059 20.0873 127.114C20.3418 127.418 20.8132 127.819 21.4514 127.685C21.977 127.572 22.1772 127.205 22.2481 126.884C22.2648 126.813 22.1647 126.772 22.1313 126.838C21.9937 127.076 21.7309 127.318 21.2178 127.351C20.8298 127.376 20.4336 127.185 20.1708 127.022V127.018Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M15.193 126.756C15.1388 126.706 15.0595 126.773 15.0929 126.835C15.2889 127.181 15.6769 127.661 16.3276 127.649C16.8657 127.636 17.1285 127.311 17.2578 127.006C17.2871 126.939 17.1995 126.881 17.1494 126.939C16.9742 127.148 16.6697 127.34 16.1566 127.277C15.7728 127.231 15.4141 126.969 15.1888 126.76L15.193 126.756Z",
    fill: "#21223D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M91.4002 111.607C91.4169 105.984 89.9611 102.209 89.9611 102.209C80.5128 101.625 64.899 102.272 64.899 102.272C64.8782 102.326 64.8573 102.38 64.8364 102.434C64.8364 102.434 65.3454 107.311 66.2422 111.411C75.4361 116.855 83.0073 116.688 91.3961 111.603L91.4002 111.607Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M41.5384 29.711C41.5384 29.711 42.3978 28.5054 42.7273 27.3291C43.0568 26.1527 43.3488 24.9096 43.5407 24.1796C43.766 23.3036 42.9192 23.4329 42.4603 24.1212C41.7637 25.1641 41.7762 25.8232 41.7762 25.8232C41.7762 25.8232 42.0557 20.9718 41.6177 19.7412C41.2172 18.6191 40.9336 21.2846 40.5706 23.4788C40.5706 23.4788 40.0242 18.7484 39.2942 18.3938C38.3348 17.9308 39.0147 23.6623 39.0147 23.6623C39.0147 23.6623 37.8842 19.5118 37.4087 19.7162C36.8747 19.9456 37.513 24.334 37.513 24.334C37.513 24.334 36.4868 21.5516 36.2157 21.7977C35.6859 22.2899 36.6244 28.5346 38.7394 30.4994C38.7394 30.4994 41.0879 30.2491 41.5384 29.7068V29.711Z",
    fill: "#F9AE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M44.8747 38.595C43.1853 33.6477 41.7461 29.4971 41.7461 29.4971C40.5698 28.8714 39.335 29.2301 38.1002 29.5972C39.0639 38.3906 41.3081 45.0983 43.5857 50.0874C46.6976 55.406 59.6375 65.5176 59.6375 65.5176C63.2291 63.8615 61.3144 58.6222 61.3144 58.6222C54.3314 52.39 47.7613 46.8462 47.6612 46.7586C47.3776 45.9284 46.3138 42.804 44.8747 38.5909V38.595Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M80.4154 32.4316C80.4154 32.4316 82.4135 33.7498 81.6961 37.3248C80.9827 40.8997 79.5978 41.2835 79.5978 41.2835C79.5978 41.2835 77.5037 33.366 80.4154 32.4316Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M72.1567 49.1299L72.2985 53.6559L72.3652 55.7291C69.9374 57.8774 65.4865 55.604 65.4865 55.604L64.452 48.9672C65.5825 48.0536 68.7361 48.4541 70.6382 48.8087C71.5351 48.9755 72.1567 49.1299 72.1567 49.1299Z",
    fill: "#F9AE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M72.157 49.1301L72.2988 53.6561C69.1911 53.2181 66.2669 49.2177 66.2669 49.2177L70.6386 48.8047C71.5354 48.9715 72.157 49.1259 72.157 49.1259V49.1301Z",
    fill: "#F58A69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M80.0114 34.2533C80.0114 34.2533 84.8878 31.9841 83.4612 27.9795C82.0304 23.9749 76.1945 25.8145 70.9468 26.0147C62.4955 26.3359 59.8508 30.7326 60.0635 35.3087C60.2763 39.8848 60.2304 46.021 62.3036 48.3111C64.3768 50.6013 65.7951 47.3642 66.8672 44.5026C67.9392 41.641 74.5635 32.8767 80.0114 34.2533Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M80.4531 38.1497C80.4531 38.304 80.449 38.4625 80.4448 38.6211C80.3572 41.4618 79.8691 44.9158 79.3852 47.7273C78.8721 50.7099 75.998 52.6789 73.0321 52.0823C69.4614 51.3607 65.0605 50.2678 63.0498 48.9454C62.4408 48.5449 62.0529 48.1236 61.9736 47.6856C61.7942 46.6595 61.6941 45.262 61.6482 43.7436C61.5064 39.1342 61.8443 33.3859 61.8443 33.3859C66.1367 28.0548 78.0963 30.1363 79.915 34.0366C80.3322 34.9293 80.474 36.4102 80.449 38.158L80.4531 38.1497Z",
    fill: "#F9AE83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M77.8105 46.4043C77.8105 46.4043 77.7563 46.5419 77.6354 46.738C77.4476 47.0425 77.0972 47.493 76.5383 47.7934C76.0127 48.077 75.3077 48.223 74.3816 47.9894C73.5598 47.7809 73.0301 47.3804 72.6922 46.9215C72.2166 46.275 72.1207 45.5032 72.1207 44.9818C72.1207 44.6189 72.1707 44.377 72.1707 44.377C74.3774 46.0455 77.8105 46.4085 77.8105 46.4085V46.4043Z",
    fill: "#921A1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M76.5371 47.7947C76.0115 48.0784 75.3065 48.2244 74.3805 47.9908C73.5587 47.7822 73.0289 47.3817 72.691 46.9229C73.2041 46.7143 74.0259 46.5766 74.9645 46.877C75.7612 47.1314 76.1617 47.4902 76.5371 47.7947Z",
    fill: "#F15D67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M77.8105 46.4043C77.8105 46.4043 77.7563 46.5419 77.6354 46.738C75.1742 46.9215 72.9508 45.5616 72.1207 44.9818C72.1207 44.6189 72.1707 44.377 72.1707 44.377C74.3774 46.0455 77.8105 46.4085 77.8105 46.4085V46.4043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M73.3633 40.7233C73.3633 41.3239 73.0963 41.8078 72.7668 41.8078C72.4372 41.8078 72.1703 41.3239 72.1703 40.7233C72.1703 40.1226 72.4372 39.6387 72.7668 39.6387C73.0963 39.6387 73.3633 40.1226 73.3633 40.7233Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M79.4648 40.7233C79.4648 41.3239 79.1979 41.8078 78.8683 41.8078C78.5388 41.8078 78.2718 41.3239 78.2718 40.7233C78.2718 40.1226 78.5388 39.6387 78.8683 39.6387C79.1979 39.6387 79.4648 40.1226 79.4648 40.7233Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M61.6273 39.5133C61.6273 39.5133 63.5378 38.2702 65.148 40.4894H66.3994C66.3994 40.4894 66.3285 37.9198 66.9375 36.5223C67.5465 35.1291 69.941 35.1624 70.2997 33.5189C70.2997 33.5189 75.9562 35.7715 80.0108 34.2489C84.0655 32.7305 71.9057 25.9727 66.0407 29.2598C60.1756 32.5511 60.7179 35.1291 61.6273 39.5091V39.5133Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M70.2456 39.3335C70.2456 39.3335 70.7128 38.1113 71.7848 37.7191C72.7776 37.3562 73.5243 37.5564 73.9081 37.7233C74.075 37.7942 74.1584 37.9819 74.1125 38.1571C74.0541 38.3657 73.833 38.4783 73.6328 38.4033C72.9946 38.1697 71.6055 37.9194 70.2498 39.3335H70.2456Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M80.3829 37.374C80.3954 37.5283 80.4038 37.6868 80.4121 37.8454C79.2566 37.4073 78.3305 37.7703 77.8633 38.0372C77.8175 38.0664 77.7632 38.0789 77.709 38.0831C77.563 38.0956 77.4128 38.0205 77.3461 37.8745C77.2668 37.7119 77.3211 37.5116 77.4712 37.4115C77.8175 37.1821 78.5183 36.8567 79.5611 37.0403C79.8698 37.0945 80.1451 37.2196 80.3829 37.3698V37.374Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M63.0504 48.942C62.4413 48.5416 62.0534 48.1203 61.9741 47.6823C61.7948 46.6561 61.6947 45.2586 61.6488 43.7402L64.8066 45.9094C64.8066 45.9094 64.8483 48.1578 63.0504 48.942Z",
    fill: "#28120E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M65.1484 40.4921C65.1484 40.4921 63.2337 38.1686 61.6277 39.5159C59.859 40.9968 61.2148 46.0234 64.8064 45.9108L65.1484 40.4921Z",
    fill: "#F9AE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M64.8936 44.8184C64.7351 44.8184 64.5974 44.7016 64.5807 44.5389C64.2887 41.9985 62.7787 41.6063 62.7161 41.5897C62.5492 41.5479 62.4408 41.3811 62.4825 41.2101C62.52 41.0432 62.6869 40.9347 62.8579 40.9723C62.9413 40.989 64.8644 41.452 65.2106 44.4638C65.2315 44.639 65.1063 44.7933 64.9311 44.8142C64.9186 44.8142 64.9061 44.8142 64.8936 44.8142V44.8184Z",
    fill: "#F58A69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M62.879 43.2047C62.804 43.2047 62.7289 43.1796 62.6663 43.1254C62.537 43.0086 62.5245 42.8125 62.6413 42.6832C62.6663 42.654 63.292 41.9657 64.3307 42.1952C64.5017 42.2327 64.6102 42.3996 64.5727 42.5706C64.5351 42.7416 64.3683 42.8501 64.1972 42.8125C63.5298 42.6665 63.1335 43.0879 63.1168 43.1045C63.0542 43.1713 62.9666 43.2088 62.8832 43.2088L62.879 43.2047Z",
    fill: "#F58A69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M74.6942 49.434C73.0715 49.434 72.2706 48.3828 72.233 48.3327C72.1288 48.1909 72.158 47.9948 72.2998 47.8905C72.4416 47.7862 72.6377 47.8154 72.742 47.9573C72.7795 48.0073 73.5888 49.0335 75.2615 48.7582C75.4325 48.729 75.5952 48.8458 75.6244 49.0168C75.6536 49.1879 75.5368 49.3505 75.3658 49.3797C75.128 49.4173 74.9069 49.4381 74.6984 49.4381L74.6942 49.434Z",
    fill: "#F58A69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M76.2348 44.2116C76.1389 44.2116 76.0471 44.1699 75.9845 44.0864C75.8803 43.9488 75.9053 43.7485 76.0429 43.6443L76.8856 43.0018L76.1556 42.8141C76.0346 42.7808 75.9428 42.6806 75.922 42.5597L75.6008 40.549C75.5716 40.378 75.6925 40.2153 75.8636 40.1861C76.0346 40.1569 76.1973 40.2737 76.2265 40.4489L76.5143 42.2552L77.674 42.5555C77.7908 42.5847 77.8784 42.6806 77.9034 42.7974C77.9284 42.9142 77.8826 43.0394 77.7866 43.1103L76.4267 44.149C76.3683 44.1907 76.3016 44.2157 76.2348 44.2157V44.2116Z",
    fill: "#F58A69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M80.1183 113.178C80.1183 113.178 96.2493 116.795 101.764 118.363C101.764 118.363 102.031 126.398 102.894 132.079C103.649 137.039 104.797 142.47 104.797 142.47L108.801 143.033C108.801 143.033 110.032 119.515 109.348 116.069C108.664 112.628 91.8985 101.682 75.9343 102.887L80.1183 113.178Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M115.392 153.489L103.052 150.256C102.468 150.101 102.11 149.543 102.181 148.971C102.189 148.892 102.21 148.808 102.235 148.729L104.433 142.38C104.433 142.38 105.009 142.276 105.772 142.297C106.227 142.309 106.665 142.092 106.903 141.709C106.919 141.679 106.936 141.65 106.953 141.621C107.562 140.449 109.464 140.524 109.476 141.829C109.476 141.996 109.476 142.163 109.468 142.318C109.468 142.355 109.468 142.397 109.464 142.434C109.447 142.71 109.422 142.96 109.397 143.181C109.397 143.185 109.397 143.189 109.397 143.194C109.322 143.748 109.226 144.09 109.226 144.09C109.335 144.341 109.439 144.587 109.539 144.829C109.589 144.95 109.639 145.067 109.689 145.188C109.798 145.442 109.898 145.688 110.002 145.926C110.048 146.038 110.098 146.147 110.144 146.251C110.261 146.51 110.373 146.756 110.494 146.99C110.548 147.094 110.603 147.198 110.657 147.302C111.116 148.137 111.641 148.762 112.371 149.067C113.66 149.601 115.809 150.323 116.351 152.563C116.363 152.609 116.368 152.654 116.372 152.7C116.401 153.213 115.913 153.639 115.387 153.501L115.392 153.489Z",
    fill: "#DE9E26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M115.391 153.488L103.052 150.256C102.468 150.101 102.105 149.542 102.18 148.971L116.376 152.692C116.405 153.205 115.917 153.63 115.391 153.493V153.488Z",
    fill: "#BE812B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M109.688 145.175C109.491 145.346 109.133 145.526 108.482 145.605C108.373 145.622 108.253 145.63 108.123 145.638L108.102 145.288C108.227 145.279 108.344 145.267 108.449 145.254C109.195 145.158 109.45 144.942 109.533 144.816C109.583 144.937 109.633 145.054 109.683 145.175H109.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M108.499 145.567C108.445 145.78 108.228 145.905 108.015 145.85C107.802 145.796 107.677 145.579 107.732 145.367C107.786 145.154 108.003 145.029 108.215 145.083C108.428 145.137 108.553 145.354 108.499 145.567Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M110.148 146.242C109.944 146.367 109.635 146.488 109.164 146.55C109.035 146.571 108.893 146.584 108.734 146.592L108.713 146.242C108.859 146.233 108.989 146.221 109.11 146.204C109.589 146.137 109.856 146.021 110.007 145.912C110.052 146.025 110.103 146.133 110.148 146.237V146.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M109.169 146.534C109.115 146.746 108.898 146.872 108.685 146.817C108.472 146.763 108.347 146.546 108.401 146.333C108.456 146.121 108.673 145.996 108.885 146.05C109.098 146.104 109.223 146.321 109.169 146.534Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M110.66 147.289C110.456 147.41 110.155 147.519 109.709 147.585C109.576 147.606 109.434 147.619 109.275 147.631L109.254 147.281C109.4 147.272 109.534 147.26 109.651 147.239C110.08 147.181 110.339 147.076 110.497 146.98C110.552 147.085 110.606 147.189 110.66 147.293V147.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M109.714 147.573C109.66 147.785 109.443 147.911 109.23 147.856C109.017 147.802 108.892 147.585 108.946 147.372C109.001 147.16 109.218 147.035 109.43 147.089C109.643 147.143 109.768 147.36 109.714 147.573Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M109.398 143.173C108.835 143.019 108.28 142.948 108.28 142.948L108.447 142.331C108.819 142.293 109.169 142.347 109.461 142.426C109.444 142.702 109.419 142.952 109.394 143.173H109.398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M96.806 126.184L113.805 148.86L110.722 151.596C102.704 143.996 95.1541 137.805 91.4082 130.977C84.421 125.733 69.4788 111.417 69.4788 111.417C70.8763 108.255 75.0227 102.619 75.0227 102.619C82.5772 108.614 96.806 126.188 96.806 126.188V126.184Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M125.376 147.487L115.298 156.43C114.822 156.852 114.117 156.843 113.654 156.443C113.588 156.384 113.529 156.322 113.475 156.251L109.187 150.594C109.187 150.594 109.433 150.027 109.9 149.368C110.175 148.976 110.246 148.463 110.046 148.029C110.029 147.996 110.013 147.966 110 147.933C109.329 146.711 110.509 145.08 111.665 145.835C111.815 145.931 111.957 146.031 112.09 146.127C112.123 146.152 112.157 146.177 112.186 146.198C112.42 146.373 112.624 146.544 112.799 146.694C112.803 146.694 112.808 146.702 112.812 146.702C113.254 147.095 113.5 147.378 113.5 147.378C113.784 147.428 114.059 147.482 114.33 147.537C114.468 147.562 114.601 147.587 114.731 147.616C115.014 147.67 115.294 147.724 115.565 147.774C115.69 147.799 115.815 147.82 115.936 147.841C116.232 147.891 116.516 147.937 116.791 147.966C116.916 147.983 117.037 147.996 117.163 148.004C118.168 148.087 119.023 147.996 119.72 147.533C120.946 146.715 122.836 145.251 125.122 146.089C125.172 146.106 125.213 146.127 125.255 146.152C125.727 146.427 125.81 147.107 125.38 147.487H125.376Z",
    fill: "#DE9E26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M125.376 147.487L115.298 156.431C114.823 156.852 114.118 156.844 113.655 156.443L125.251 146.152C125.723 146.428 125.806 147.108 125.376 147.487Z",
    fill: "#BE812B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M114.731 147.617C114.765 147.892 114.715 148.309 114.402 148.926C114.352 149.031 114.289 149.143 114.222 149.26L113.901 149.072C113.968 148.956 114.026 148.847 114.076 148.747C114.431 148.034 114.389 147.683 114.327 147.533C114.464 147.558 114.598 147.583 114.727 147.612L114.731 147.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M114.372 148.893C114.527 149.064 114.51 149.331 114.339 149.482C114.168 149.636 113.901 149.619 113.751 149.448C113.597 149.277 113.613 149.01 113.784 148.86C113.955 148.706 114.222 148.722 114.372 148.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M115.933 147.842C115.925 148.097 115.846 148.439 115.629 148.889C115.57 149.014 115.499 149.148 115.416 149.294L115.095 149.106C115.174 148.973 115.237 148.852 115.295 148.735C115.516 148.276 115.57 147.971 115.566 147.775C115.691 147.8 115.817 147.821 115.938 147.842H115.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M115.621 148.874C115.775 149.045 115.758 149.312 115.587 149.462C115.416 149.616 115.149 149.6 114.999 149.429C114.845 149.258 114.861 148.991 115.032 148.84C115.203 148.686 115.47 148.703 115.621 148.874Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M117.156 148.004C117.144 148.255 117.064 148.584 116.856 149.014C116.798 149.143 116.722 149.277 116.639 149.423L116.318 149.235C116.397 149.101 116.46 148.976 116.518 148.864C116.718 148.451 116.781 148.163 116.785 147.967C116.91 147.983 117.031 147.996 117.156 148.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M116.847 149.003C117.001 149.174 116.985 149.441 116.814 149.591C116.643 149.745 116.376 149.729 116.226 149.558C116.071 149.386 116.088 149.12 116.259 148.969C116.43 148.815 116.697 148.832 116.847 149.003Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M112.799 146.698C112.332 147.102 111.948 147.544 111.948 147.544L111.506 147.035C111.689 146.689 111.948 146.41 112.186 146.201C112.419 146.376 112.624 146.547 112.799 146.698Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M93.1292 25.1965C93.1292 25.1965 92.0738 24.1578 91.544 23.0565C91.0184 21.9553 90.5095 20.7831 90.1966 20.0948C89.8212 19.2688 90.6805 19.2522 91.252 19.8487C92.1197 20.7581 92.2198 21.4046 92.2198 21.4046C92.2198 21.4046 91.106 16.6742 91.3229 15.3852C91.5232 14.2089 92.2657 16.7868 92.9998 18.8851C92.9998 18.8851 92.7162 14.1296 93.3753 13.6582C94.2388 13.0367 94.5641 18.7975 94.5641 18.7975C94.5641 18.7975 94.9563 14.5134 95.461 14.6302C96.0241 14.7637 96.1618 19.1979 96.1618 19.1979C96.1618 19.1979 96.6916 16.2779 96.9961 16.4781C97.6051 16.8703 97.7636 23.1817 96.02 25.4843C96.02 25.4843 93.6631 25.6428 93.125 25.1923L93.1292 25.1965Z",
    fill: "#F9AE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M91.3849 34.5273C92.19 29.3631 92.8866 25.0247 92.8866 25.0247C93.9379 24.203 95.2143 24.3406 96.495 24.4908C97.0748 33.3176 96.0277 40.3131 94.6512 45.6234C92.5112 51.4009 81.5194 63.6065 81.5194 63.6065C77.6942 62.6012 78.6703 57.1074 78.6703 57.1074C84.4645 49.7573 89.9708 43.1581 90.0584 43.0538C90.1919 42.1861 90.6966 38.924 91.3849 34.5231V34.5273Z",
    fill: "#21223D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M64.9604 103.258C65.1273 103.855 65.5611 104.351 66.1493 104.635C67.0545 105.073 65.3025 104.626 67.3256 104.914C69.1527 105.177 76.4277 106.654 78.3091 106.479C79.9735 106.345 80.5742 106.245 82.1051 105.782C84.0907 105.181 86.6311 104.18 88.9254 102.991C89.9307 102.47 90.3896 101.348 90.0058 100.347L84.5787 80.5696C84.512 80.3903 84.4661 80.2025 84.4536 80.0107L80.5283 58.2273C80.449 57.247 79.6689 56.4461 78.6303 56.2834L73.7789 55.5117L71.7891 55.1989C70.692 55.0236 69.5782 54.9903 68.4769 55.0779C67.3757 55.1822 66.2869 55.4074 65.2357 55.7703L63.0916 56.5129L58.6865 58.0313C57.6937 58.3733 57.0639 59.2952 57.1515 60.2755L60.2133 82.4176C60.2258 82.5386 60.2467 82.6554 60.2759 82.7722L64.9562 103.267L64.9604 103.258Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M63.3429 56.5622L71.9361 105.535C73.7841 105.664 75.5986 105.585 77.4591 105.268C79.1068 105.01 80.6419 104.588 82.127 104.004L81.9226 102.79L81.714 101.522L81.2218 98.5729L81.009 97.3048L80.5168 94.3598L80.3082 93.0917L79.8118 90.1466L79.6032 88.8827L79.111 85.9376L78.8983 84.6778L78.406 81.7286L78.1975 80.4647L77.7052 77.5154L77.4925 76.2557L77.0002 73.3023L76.7875 72.0467L76.2953 69.0891L76.0867 67.8335L75.5945 64.8759L75.3817 63.6245L74.8895 60.6711L74.6767 59.4197L74.1845 56.4579L74.0177 55.6737L74.001 55.5694L71.9444 54.9312C70.8348 54.8352 69.7211 54.8853 68.6281 55.0522C67.5394 55.2399 66.2462 55.3275 65.2284 55.7738L63.7517 56.2827L63.3346 56.5706L63.3429 56.5622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M63.6181 58.188L63.835 59.4228C65.733 59.4228 67.5559 59.2351 69.212 58.9597C71.2602 58.6218 73.0581 58.1546 74.418 57.7417L74.2136 56.4902C71.8191 57.2286 67.8813 58.188 63.6431 58.1797L63.6222 58.188H63.6181Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M64.2357 61.7039L64.4526 62.947C66.3256 62.947 68.1235 62.7676 69.7545 62.4965C71.8236 62.1586 73.634 61.6789 74.998 61.2534L74.7853 60.002C72.3909 60.7528 68.4697 61.7248 64.2315 61.7039H64.2357Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M64.8687 65.3194L65.0898 66.5708C66.9377 66.575 68.7064 66.3998 70.3166 66.1328C72.3982 65.7908 74.2169 65.3027 75.5977 64.8647L75.3849 63.6133C72.9988 64.3808 69.0985 65.3653 64.8687 65.3194Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M65.6118 69.5429L65.8329 70.7943C67.66 70.8026 69.4037 70.6274 70.993 70.3688C73.0829 70.0267 74.9058 69.5303 76.2949 69.0798L76.0863 67.8242C73.7003 68.6043 69.825 69.5971 65.6077 69.5429H65.6118Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M66.3542 73.7683L66.5753 75.0155C68.3732 75.028 70.1002 74.8612 71.677 74.6026C73.7794 74.2563 75.6106 73.7516 77.0039 73.2927L76.7912 72.0371C74.4134 72.8297 70.5674 73.8267 66.3542 73.7683Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M67.0949 77.9853L67.3159 79.2368C69.0972 79.2576 70.7991 79.0908 72.3551 78.8363C74.4658 78.4901 76.3054 77.9728 77.707 77.5098L77.4943 76.25C75.1249 77.0593 71.2955 78.0646 67.0949 77.9895V77.9853Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M67.8338 82.2068L68.0549 83.4583C69.8153 83.4791 71.5047 83.3206 73.044 83.0703C75.1547 82.7241 76.9985 82.2027 78.4043 81.7229L78.1957 80.459C75.8263 81.2808 72.0261 82.2944 67.8338 82.211V82.2068Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M68.5784 86.4239L68.7995 87.6753C70.5473 87.7045 72.2159 87.5502 73.7385 87.2999C75.8576 86.9537 77.7014 86.4239 79.1113 85.9317L78.8986 84.6719C76.5375 85.5062 72.7582 86.524 68.5784 86.4281V86.4239Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M69.3193 90.6456L69.5404 91.9013C71.2716 91.9305 72.9235 91.7761 74.4335 91.5258C76.5526 91.1796 78.3923 90.6415 79.8105 90.1409L79.602 88.877C77.2493 89.7321 73.4908 90.7541 69.3193 90.6498V90.6456Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M70.062 94.8671L70.2831 96.1186C72.0017 96.152 73.6369 96.006 75.1344 95.7598C77.2535 95.4136 79.0973 94.8672 80.5156 94.3541L80.3071 93.0859C77.9544 93.9536 74.2251 94.9839 70.062 94.8671Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M70.8046 99.084L71.0257 100.344C72.7318 100.381 74.3503 100.235 75.8354 99.9933C77.9586 99.6471 79.8024 99.0965 81.2207 98.5709L81.008 97.3027C78.6636 98.1787 74.9552 99.2174 70.8046 99.0881V99.084Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M71.5433 103.307L71.7644 104.567C73.458 104.604 75.0598 104.462 76.5365 104.22C78.6556 103.874 80.4994 103.319 81.9219 102.79L81.7133 101.521C79.3731 102.406 75.6856 103.449 71.5475 103.307H71.5433Z",
    fill: "#E2E2E2"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M102.982 103.188L103.385 107.458C103.391 107.524 103.343 107.583 103.276 107.589L68.9058 110.832C68.8392 110.839 68.7802 110.79 68.774 110.723L68.3711 106.454C68.3649 106.388 68.4137 106.329 68.4802 106.322L102.851 103.079C102.917 103.073 102.976 103.122 102.982 103.188Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M107.015 107.228C108.317 107.107 109.376 106.123 109.593 104.834L113.781 79.9803C114.036 78.4619 112.784 77.1145 111.249 77.2564L95.7524 78.7164C94.7054 78.8165 93.8544 79.5966 93.6667 80.6311L88.5149 108.972L107.015 107.228Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M98.1524 102.109L98.3359 100.774L97.2847 100.854L97.6018 99.623L96.2085 99.7315L95.8915 100.962L95.0321 101.029L95.3492 99.7982L93.9559 99.9067L93.6389 101.137L92.4208 101.229L92.2373 102.564L93.2885 102.485L93.0048 103.615L91.7868 103.707L91.6032 105.042L92.6544 104.963L92.3374 106.193L93.7307 106.085L94.0477 104.854L94.907 104.787L94.59 106.018L95.9832 105.909L96.3003 104.679L97.5183 104.587L97.7019 103.252L96.6507 103.331L96.9343 102.201L98.1524 102.109ZM95.2574 103.44L94.3981 103.507L94.6817 102.376L95.5411 102.309L95.2574 103.44Z",
    fill: "#6BD17C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M111.87 84.0795C111.507 85.7021 110.034 87.1204 108.578 87.2498C107.123 87.3749 106.238 86.1652 106.601 84.5425C106.964 82.9198 108.437 81.5015 109.892 81.3722C111.348 81.247 112.233 82.4568 111.87 84.0795Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M108.925 83.7826C108.854 84.108 108.691 84.3791 108.566 84.3916C108.441 84.4042 108.395 84.1497 108.47 83.8243C108.541 83.4989 108.704 83.2278 108.829 83.2153C108.954 83.2028 109 83.4572 108.925 83.7826Z",
    fill: "#28100C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M110.298 83.6615C110.227 83.9869 110.064 84.258 109.939 84.2705C109.814 84.2831 109.768 84.0286 109.843 83.7032C109.914 83.3778 110.077 83.1067 110.202 83.0942C110.327 83.0817 110.373 83.3361 110.298 83.6615Z",
    fill: "#28100C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M108.936 85.7345C107.801 85.8347 107.826 84.5916 107.826 84.5791C107.826 84.5123 107.885 84.4414 107.947 84.4205C108.014 84.3997 108.064 84.4372 108.06 84.5081C108.06 84.554 108.047 85.5635 108.99 85.4801C109.937 85.3967 110.383 84.3455 110.4 84.3037C110.429 84.2328 110.5 84.1828 110.559 84.1953C110.617 84.2036 110.642 84.2704 110.613 84.3413C110.609 84.3538 110.066 85.6386 108.932 85.7387L108.936 85.7345Z",
    fill: "#28100C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M93.6604 80.6354L88.5503 108.743L86.7775 108.91L91.8875 80.8023C92.0752 79.7677 92.9262 78.9835 93.9732 78.8876L95.7461 78.7207C94.6991 78.8208 93.8481 79.6009 93.6604 80.6354Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M88.7118 108.554C88.7118 108.554 88.6826 108.554 88.6659 108.55C88.5241 108.525 88.4282 108.388 88.4574 108.246L93.509 80.2011C93.534 80.0593 93.6717 79.9633 93.8135 79.9883C93.9554 80.0134 94.0513 80.151 94.0221 80.2929L88.9705 108.338C88.9496 108.463 88.837 108.554 88.7118 108.554Z",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M99.3013 93.567C99.0927 95.1229 100.156 96.2659 101.679 96.1241C103.202 95.9823 104.603 94.6015 104.812 93.0456C105.02 91.4896 103.957 90.3466 102.434 90.4885C100.911 90.6303 99.5099 92.011 99.3013 93.5628V93.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M61.62 126.134C61.0652 126.134 60.4687 125.942 59.8596 125.562C57.6404 124.173 54.954 119.96 53.957 113.686C53.9362 113.544 54.0321 113.411 54.1739 113.386C54.3158 113.361 54.4492 113.461 54.4743 113.603C55.4462 119.718 58.02 123.793 60.1391 125.12C60.8608 125.57 61.5449 125.716 62.1164 125.541C62.5752 125.399 62.934 125.087 63.201 124.578C65.0489 121.094 61.8369 110.603 61.8035 110.499C61.7618 110.361 61.8369 110.215 61.9745 110.174C62.1122 110.132 62.2582 110.207 62.2999 110.345C62.4376 110.783 65.6079 121.153 63.6598 124.824C63.3261 125.454 62.8547 125.862 62.2624 126.042C62.0538 126.104 61.8369 126.138 61.6158 126.138L61.62 126.134Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_118725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 156.566,
    fill: "white",
    transform: "matrix(-1 0 0 1 200 0.984375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationPageLogo);
export default __webpack_public_path__ + "static/media/registrationPageLogo.9dfe737cf3d6b43c42dc0a3ca3ddd50d.svg";
export { ForwardRef as ReactComponent };